import { css } from "@microsoft/fast-element";
import { display, spacingVerticalXXS, spacingHorizontalL, spacingHorizontalXL } from "@fluentui/web-components";
export const styles = css `
  ${display("flex")}

  :host {
    contain: content;
    flex-direction: column;
    height: fit-content;
    max-width: calc(${spacingHorizontalXL} * 15);
    min-width: calc(${spacingHorizontalL} * 10);
    width: auto;
    background-color: var(--colorNeutralBackground1);
    border: 1px solid var(--colorTransparentStroke);
    border-radius: var(--borderRadiusMedium);
    box-shadow: var(--shadow16);
    row-gap: ${spacingVerticalXXS};
  }
`;
//# sourceMappingURL=accordion-menu.styles.js.map